<script setup lang="ts">
const props = defineProps<{
  open: boolean;
}>();

const emit = defineEmits<{
  'update:open': [val: boolean];
}>();

const { $trpc } = useNuxtApp();
const notifyStore = useNotifyStore();
const { NotificationType } = await import('~/stores/notify.store');

const message = ref('');
const sending = ref(false);

async function submit() {
  if (!message.value.trim()) return;
  sending.value = true;
  try {
    await $trpc.support.submitContactRequest.mutate({
      message: message.value.trim(),
    });
    notifyStore.notify('Your message has been sent to support!', NotificationType.Success);
    message.value = '';
    emit('update:open', false);
  } catch (e: any) {
    notifyStore.notify(e?.message || 'Failed to send message', NotificationType.Error);
  } finally {
    sending.value = false;
  }
}
</script>

<template>
  <UModal :open="open" title="Contact Support" @update:open="emit('update:open', $event)">
    <template #body>
      <div class="space-y-4">
        <p class="text-sm text-gray-500 dark:text-gray-400">
          How can we help you? Describe the issue or ask a question, and our team will get back to you via email.
        </p>
        
        <UFormField label="Message" required>
          <UTextarea 
            v-model="message" 
            :rows="5" 
            placeholder="Type your message here..." 
            class="w-full"
          />
        </UFormField>
      </div>
    </template>
    <template #footer>
      <div class="flex gap-2 justify-end">
        <UButton variant="ghost" color="neutral" @click="emit('update:open', false)">Cancel</UButton>
        <UButton color="primary" icon="i-heroicons-paper-airplane" :loading="sending" :disabled="!message" @click="submit">Send Message</UButton>
      </div>
    </template>
  </UModal>
</template>
